import React from "react";
import Layout from './Layout';
import DeleteAccount from '../../components/User/DeleteAccount/DeleteAccount'

export const DeleteAccountPage = () => <Layout><DeleteAccount></DeleteAccount></Layout> 
